import { RequestDocument, gql } from 'graphql-request';

export const AI_FLOW_QUERY_FRAGMENT = gql`
  {
    id
    title
    steps {
      label
      systemMessageTemplate
      userPromptTemplate
      overrideMessagesFromStep
      maxAttempts
      iterateOver
      modelName
      temperature
      temperatureFunction
      retryConditionFunction
      filterFunction
      reducerFunction
    }
    resultMapperFunction
    logEnabled
  }
`;

export const AI_FLOW_BY_TITLE_AND_ACTIVE_QUERY: RequestDocument = gql`
  query getAiFlow($title: String!) {
    aiFlow(
      filter: {
        title: { eq: $title }
        active: { eq: true }
      }
    ) ${AI_FLOW_QUERY_FRAGMENT}
  }
`;

export const AI_PROMPT_QUERY_FRAGMENT = gql`
  {
    id
    promptFields {
      id
      name
      description
    }
    description
    title
    followUp
  }
`;

export const ALL_AI_PROMPTS_QUERY: RequestDocument = gql`
  query {
    allAiPrompts(first: 100) ${AI_PROMPT_QUERY_FRAGMENT}
  }
`;

export const AI_PROMPT_BY_TITLE_QUERY: RequestDocument = gql`
  query getAiPrompt($title: String!) {
    aiPrompt(
      filter: { title: { eq: $title } }
    ) ${AI_PROMPT_QUERY_FRAGMENT}
  }
`;

export const STORIES_ARTIFACT_AI_TITLE_QUERY: RequestDocument = gql`
  query getStories($ids: [ItemId]) {
    allStories(filter: { id: { in: $ids } }) {
      id
      storyArtifacts {
        id
        title
      }
    }
  }
`;

export const SHOWCASES_ARTIFACT_AI_TITLE_QUERY: RequestDocument = gql`
  query getShowcases($ids: [ItemId]) {
    allShowcases(filter: { id: { in: $ids } }) {
      id
      organizationArtifacts {
        id
        title
      }
    }
  }
`;
